import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue3-cookies";
import { router } from "@/routes/index.js";
import { i18n } from "@/i18n/index.js";
import { $router, $axios } from "@/dot-ui/index.js";
import VueGtag from "vue-gtag";
// Bootstrap 설정
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js"
import 'bootstrap-icons/font/bootstrap-icons.css';
// ---------------------------------
// app 선언
// ---------------------------------
const app = createApp(App);
app.use(VueAxios, axios);       // axios 사용
app.use(VueCookies);            // 쿠키 사용
app.use(router);                // 라우터 사용
app.use(i18n);                  // 다국어 사용
if (process.env.NODE_ENV === "production") {
  app.use(VueGtag, {    // Google Analytics 사용
    config: {id: "G-P3LCD4HX7E"}
  }, router);
}
app.mount("#app");

// ---------------------------------
// 전역변수 선언
// ---------------------------------
app.config.globalProperties.SITE_NO = "S220121001"; // 닷 개발자 사이트
app.config.globalProperties.COMP_NO = "C220121001"; // 주식회사 닷

// ---------------------------------
// 라우트 이동처리 및 axios 인터셉터 처리
// ---------------------------------
$router.setBeforeEach(router);
$axios.interceptorsRequest();
$axios.interceptorsResponse();
